import * as TYPES from './types';

export const treatmentSummaryItemsLoaded = (items) => ({
  type: TYPES.TREATMENT_SUMMARY_LOADED_SUCCESS,
  state: {
    treatmentSummaryItems: items,
  },
});

export const treatmentSummaryItemsFailed = (message) => ({
  type: TYPES.TREATMENT_SUMMARY_LOADED_FAILED,
  error: message,
});

export const unseenTreatmentSummaryCountLoaded = (unseenCount) => ({
  type: TYPES.UNSEEN_TREATMENT_SUMMARY_COUNT_SUCCESS,
  state: {
    unseenTreatmentSummaryItems: unseenCount,
  },
});

export const unseenTreatmentSummaryCountFailed = (message) => ({
  type: TYPES.UNSEEN_TREATMENT_SUMMARY_COUNT_FAILED,
  error: message,
});
